import Grid from '@components/core/layout/Grid';
import { Image } from '@core/Image';
import Button from '@components/core/Button';
import RichText from '@components/core/RichText';
import { getInternalPath } from '@helpers/internalLink';

export default function ImageTextSection(props) {
  let ctaSolidLink = undefined;
  let ctaGhostLink = undefined;

  if (props.ctaSolid && props.ctaSolid.link) {
    ctaSolidLink = props.ctaSolid.link.internalLink ? getInternalPath(props.ctaSolid.link.internalLink) : props.ctaSolid.link.externalUrl;
  }

  if (props.ctaGhost && props.ctaGhost.link) {
    ctaGhostLink = props.ctaGhost.link.internalLink ? getInternalPath(props.ctaGhost.link.internalLink) : props.ctaGhost.link.externalUrl;
  }

  const imageShape = props.imageShape ?? 'oval';
  const shapeClasses = {
    none: 'rounded-none',
    oval: 'rounded-[128px] md:rounded-[180px]',
    ovalTwoCorners: 'rounded-tl-[128px] rounded-br-[128px] md:rounded-tl-[180px] md:rounded-br-[180px]',
  };
  const shapeClass = shapeClasses[imageShape] ?? shapeClasses.oval;

  return (
    <Grid className='items-center'>
      <div className={ `col-span-12 xl:col-span-6 mb-8 md:mb-12 xl:mb-0 relative w-[343px] h-[322px] md:w-full md:aspect-[4/3] md:h-auto order-1 overflow-hidden ${ shapeClass } ${ props.imageAlignLeft ? 'md:col-start-1' : 'md:!col-end-13 md:order-2' }` }>
        <Image
          sanityImage={ props.headerImage.image }
          className={ shapeClass }
          layout='fill'
          objectFit='cover'
          sizes='(min-width: 1280px) 650px, (min-width: 768px) 850px, 400px'
        />
      </div>
      <div className={ `col-span-12 xl:col-span-4 order-2 ${ props.imageAlignLeft ? ' xl:col-start-8' : ' xl:col-start-1 xl:order-1' }` }>
        <div className='text-heading-md text-heading-md--semibold mb-4'>{ props.heading }</div>
        <RichText text={ props.intro?.text } />
        {
          ctaSolidLink &&
          <Button type='solid' href={ ctaSolidLink } externalUrl={ props.ctaSolid.link.externalUrl ? true : false } className='mr-3 mb-3'>
            <span className='mr-3'>{ props.ctaSolid.label}</span>
          </Button>
        }
        {
          ctaGhostLink &&
          <Button type='ghost' href={ ctaGhostLink } externalUrl={ props.ctaGhost.link.externalUrl ? true : false }>
            <span className='mr-3'>{ props.ctaGhost.label}</span>
          </Button>
        }
      </div>
    </Grid>
  );
}
